import React from 'react';
import ProtectedSwagger from '../components/ProtectedSwagger';
import { services } from '../config/services';

const service = services.find((item) => item.route === '/lista-nominal');

const DicioBackConnectionIneAPIDoc = () => (
    <ProtectedSwagger
        service={service}
        url={process.env.PUBLIC_URL + '/json/openapi/dicio-back-connection-ine_openapi.json'}
    />
);

export default DicioBackConnectionIneAPIDoc;
